// // import React, { useState, useEffect } from 'react';
// // import { Menu, X } from 'lucide-react';
// // import { Link, useLocation } from 'react-router-dom';

// // const Header = () => {
// //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// //   const [scrollY, setScrollY] = useState(0);
// //   const [isVisible, setIsVisible] = useState(true);
// //   const [lastScrollY, setLastScrollY] = useState(0);
// //   const location = useLocation();

// //   // Scroll handler for navbar background and visibility
// //   useEffect(() => {
// //     const handleScroll = () => {
// //       const currentScrollY = window.scrollY;
      
// //       // Show/hide navbar based on scroll direction
// //       if (currentScrollY > lastScrollY && currentScrollY > 100) {
// //         setIsVisible(false); // Hide when scrolling down
// //       } else {
// //         setIsVisible(true); // Show when scrolling up
// //       }
      
// //       setScrollY(currentScrollY);
// //       setLastScrollY(currentScrollY);
// //     };

// //     window.addEventListener('scroll', handleScroll, { passive: true });
// //     return () => window.removeEventListener('scroll', handleScroll);
// //   }, [lastScrollY]);

// //   // Close mobile menu when route changes
// //   useEffect(() => {
// //     setIsMenuOpen(false);
// //   }, [location]);

// //   // Close mobile menu when clicking outside
// //   useEffect(() => {
// //     const handleClickOutside = (event) => {
// //       if (isMenuOpen && !event.target.closest('.mobile-menu-container')) {
// //         setIsMenuOpen(false);
// //       }
// //     };

// //     if (isMenuOpen) {
// //       document.addEventListener('click', handleClickOutside);
// //       document.body.style.overflow = 'hidden';
// //     } else {
// //       document.body.style.overflow = 'unset';
// //     }

// //     return () => {
// //       document.removeEventListener('click', handleClickOutside);
// //       document.body.style.overflow = 'unset';
// //     };
// //   }, [isMenuOpen]);

// //   const navigationItems = [
// //     { name: 'Home', path: '/' },
// //     { name: 'Services', path: '/services' },
// //     { name: 'About', path: '/about' },
// //     { name: 'Contact', path: '/contact' },
// //   ];

// //   const isActiveRoute = (path) => {
// //     if (path === '/' && location.pathname === '/') return true;
// //     if (path !== '/' && location.pathname.startsWith(path)) return true;
// //     return false;
// //   };

// //   return (
// //     <>
// //       {/* Load Fonts */}
// //       <link
// //         href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;900&family=Inter:wght@300;400;500;600&display=swap"
// //         rel="stylesheet"
// //       />

// //       {/* Enhanced Header Animations CSS */}
// //       <style jsx>{`
// //         .nav-header {
// //           transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
// //         }
        
// //         .nav-hidden {
// //           transform: translateY(-100%);
// //         }
        
// //         .nav-visible {
// //           transform: translateY(0);
// //         }
        
// //         .logo {
// //           transition: all 0.3s ease;
// //           position: relative;
// //           overflow: hidden;
// //         }
        
// //         .logo::before {
// //           content: '';
// //           position: absolute;
// //           bottom: -2px;
// //           left: 50%;
// //           width: 0;
// //           height: 2px;
// //           background: linear-gradient(90deg, transparent, #8b7355, transparent);
// //           transition: all 0.4s ease;
// //           transform: translateX(-50%);
// //         }
        
// //         .logo:hover::before {
// //           width: 100%;
// //         }
        
// //         .logo:hover {
// //           transform: translateY(-1px);
// //           color: #8b7355;
// //         }
        
// //         .nav-link {
// //           position: relative;
// //           transition: all 0.3s ease;
// //           overflow: hidden;
// //         }
        
// //         .nav-link::before {
// //           content: '';
// //           position: absolute;
// //           bottom: -2px;
// //           left: 0;
// //           width: 0;
// //           height: 2px;
// //           background: #8b7355;
// //           transition: width 0.3s ease;
// //         }
        
// //         .nav-link:hover::before,
// //         .nav-link.active::before {
// //           width: 100%;
// //         }
        
// //         .nav-link:hover {
// //           color: #8b7355;
// //           transform: translateY(-1px);
// //         }
        
// //         .nav-link.active {
// //           color: #57534e;
// //           font-weight: 600;
// //         }
        
// //         .mobile-menu {
// //           transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
// //           backdrop-filter: blur(20px);
// //         }
        
// //         .mobile-menu-item {
// //           opacity: 0;
// //           transform: translateX(-20px);
// //           transition: all 0.3s ease;
// //         }
        
// //         .mobile-menu-item.animate {
// //           opacity: 1;
// //           transform: translateX(0);
// //         }
        
// //         .mobile-menu-item:hover {
// //           transform: translateX(10px);
// //           color: #8b7355;
// //         }
        
// //         .mobile-menu-item.active {
// //           color: #8b7355;
// //           font-weight: 600;
// //         }
        
// //         .hamburger {
// //           transition: all 0.3s ease;
// //         }
        
// //         .hamburger:hover {
// //           transform: scale(1.1);
// //         }
        
// //         .mobile-overlay {
// //           background: rgba(0, 0, 0, 0.5);
// //           backdrop-filter: blur(10px);
// //           transition: all 0.3s ease;
// //         }
        
// //         html {
// //           scroll-behavior: smooth;
// //         }
// //       `}</style>

// //       {/* Navigation Header */}
// //       <nav className={`nav-header fixed top-0 w-full z-50 ${
// //         isVisible ? 'nav-visible' : 'nav-hidden'
// //       } ${
// //         scrollY > 50 
// //           ? 'bg-[#f5f1eb]/95 backdrop-blur-md shadow-lg border-b border-stone-200/20' 
// //           : 'bg-[#f5f1eb]/80 backdrop-blur-sm'
// //       }`}>
// //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
// //           <div className="flex items-center justify-between">
// //             {/* Logo */}
// //             <Link 
// //               to="/" 
// //               className="logo text-xl sm:text-2xl font-bold text-stone-900" 
// //               style={{fontFamily: "'Playfair Display', serif"}}
// //             >
// //               LUXE INTERIORS
// //             </Link>
            
// //             {/* Desktop Navigation */}
// //             <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
// //               {navigationItems.map((item, index) => (
// //                 <Link
// //                   key={item.name}
// //                   to={item.path}
// //                   className={`nav-link text-sm lg:text-base font-medium transition-colors duration-300 ${
// //                     isActiveRoute(item.path)
// //                       ? 'active text-stone-900'
// //                       : 'text-stone-600 hover:text-stone-900'
// //                   }`}
// //                   style={{ transitionDelay: `${index * 50}ms` }}
// //                 >
// //                   {item.name}
// //                 </Link>
// //               ))}
// //             </div>

// //             {/* Mobile Menu Button */}
// //             <button 
// //               onClick={() => setIsMenuOpen(!isMenuOpen)}
// //               className="md:hidden p-2 hamburger rounded-full hover:bg-stone-200/50 transition-all duration-300"
// //               aria-label="Toggle menu"
// //             >
// //               {isMenuOpen ? 
// //                 <X className="w-6 h-6 text-stone-900" /> : 
// //                 <Menu className="w-6 h-6 text-stone-900" />
// //               }
// //             </button>
// //           </div>
// //         </div>
// //       </nav>

// //       {/* Mobile Menu Overlay */}
// //       {isMenuOpen && (
// //         <div 
// //           className="mobile-overlay fixed inset-0 z-40 md:hidden"
// //           onClick={() => setIsMenuOpen(false)}
// //         />
// //       )}

// //       {/* Mobile Menu */}
// //       <div className={`mobile-menu-container md:hidden fixed top-0 right-0 h-full w-80 max-w-[80vw] z-50 transition-transform duration-400 ${
// //         isMenuOpen ? 'translate-x-0' : 'translate-x-full'
// //       }`}>
// //         <div className="mobile-menu h-full bg-[#f5f1eb]/95 backdrop-blur-md shadow-2xl border-l border-stone-200/20">
// //           {/* Mobile Menu Header */}
// //           <div className="flex items-center justify-between p-6 border-b border-stone-200/20">
// //             <span 
// //               className="text-lg font-bold text-stone-900" 
// //               style={{fontFamily: "'Playfair Display', serif"}}
// //             >
// //               Menu
// //             </span>
// //             <button 
// //               onClick={() => setIsMenuOpen(false)}
// //               className="p-2 rounded-full hover:bg-stone-200/50 transition-all duration-300"
// //             >
// //               <X className="w-5 h-5 text-stone-900" />
// //             </button>
// //           </div>
          
// //           {/* Mobile Menu Items */}
// //           <div className="py-6">
// //             {navigationItems.map((item, index) => (
// //               <Link
// //                 key={item.name}
// //                 to={item.path}
// //                 className={`mobile-menu-item block px-6 py-4 text-lg font-medium transition-all duration-300 ${
// //                   isActiveRoute(item.path)
// //                     ? 'active text-stone-900 bg-stone-200/30'
// //                     : 'text-stone-700 hover:text-stone-900 hover:bg-stone-200/20'
// //                 } ${isMenuOpen ? 'animate' : ''}`}
// //                 style={{ 
// //                   transitionDelay: isMenuOpen ? `${index * 100 + 200}ms` : '0ms',
// //                   fontFamily: "'Inter', sans-serif"
// //                 }}
// //                 onClick={() => setIsMenuOpen(false)}
// //               >
// //                 {item.name}
// //               </Link>
// //             ))}
            
// //             {/* Contact Information in Mobile Menu */}
// //             <div className={`mobile-menu-item px-6 py-6 mt-8 border-t border-stone-200/20 ${isMenuOpen ? 'animate' : ''}`}
// //                  style={{ transitionDelay: isMenuOpen ? `${navigationItems.length * 100 + 300}ms` : '0ms' }}>
// //               <div className="text-sm text-stone-600 space-y-2">
// //                 <p className="font-medium text-stone-900 mb-3" style={{fontFamily: "'Playfair Display', serif"}}>
// //                   Get in Touch
// //                 </p>
// //                 <p>+1 (555) 123-4567</p>
// //                 <p>hello@luxeinteriors.com</p>
// //                 <p className="text-xs text-stone-500 mt-4">
// //                   123 Design Avenue<br />
// //                   New York, NY 10001
// //                 </p>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </>
// //   );
// // };

// // export default Header;


// import React, { useState, useEffect } from 'react';
// import { Menu, X } from 'lucide-react';
// import { useLocation, useNavigate } from 'react-router-dom';

// const Header = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [scrollY, setScrollY] = useState(0);
//   const [isVisible, setIsVisible] = useState(true);
//   const [lastScrollY, setLastScrollY] = useState(0);
//   const [clickedItem, setClickedItem] = useState(null);
//   const location = useLocation();
//   const navigate = useNavigate();

//   useEffect(() => {
//     const handleScroll = () => {
//       const currentScrollY = window.scrollY;
      
//       if (currentScrollY > lastScrollY && currentScrollY > 100) {
//         setIsVisible(false);
//       } else {
//         setIsVisible(true);
//       }
      
//       setScrollY(currentScrollY);
//       setLastScrollY(currentScrollY);
//     };

//     window.addEventListener('scroll', handleScroll, { passive: true });
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, [lastScrollY]);

//   const navigationItems = [
//     { name: 'Home', path: '/' },
//     { name: 'Services', path: '/services' },
//     { name: 'About', path: '/about' },
//     { name: 'Contact', path: '/contact' },
//   ];

// //   const isActiveRoute = (path) => {
// //     if (path === '/' && currentPath === '/') return true;
// //     if (path !== '/' && currentPath.startsWith(path)) return true;
// //     return false;
// //   };

// //   const handleNavClick = (item) => {
// //     setClickedItem(item.name);
// //     setIsMenuOpen(false);
    
// //     // Reset click state after animation
// //     setTimeout(() => {
// //       setClickedItem(null);
// //     }, 300);

  
//   const isActiveRoute = (path) => {
//     if (path === '/' && location.pathname === '/') return true;
//     if (path !== '/' && location.pathname.startsWith(path)) return true;
//     return false;
//   };

//   const handleNavClick = (item) => {
//     setClickedItem(item.name);
//     setIsMenuOpen(false);
    
//     // Reset click state after animation
//     setTimeout(() => {
//       setClickedItem(null);
//     }, 300);
    
//     // Navigate with React Router
//     navigate(item.path);
//   };
    
//     // Simulate navigation (replace with actual router navigation)
  

//   return (
//     <>
//       {/* Load Fonts */}
//       <link
//         href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;900&family=Inter:wght@300;400;500;600&display=swap"
//         rel="stylesheet"
//       />

//       <style jsx>{`
//         .nav-header {
//           transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
//         }
        
//         .nav-hidden { 
//           transform: translateY(-100%); 
//         }
        
//         .nav-visible { 
//           transform: translateY(0); 
//         }
        
//         /* Enhanced Logo Animations */
//         .logo { 
//           transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
//           position: relative;
//           overflow: hidden;
//         }
        
//         .logo::before {
//           content: '';
//           position: absolute;
//           bottom: -2px;
//           left: 50%;
//           width: 0;
//           height: 2px;
//           background: linear-gradient(90deg, transparent, #8b7355, transparent);
//           transition: all 0.4s ease;
//           transform: translateX(-50%);
//         }
        
//         .logo:hover::before {
//           width: 100%;
//         }
        
//         .logo:hover { 
//           transform: translateY(-2px);
//           color: #8b7355;
//           text-shadow: 0 2px 8px rgba(139, 115, 85, 0.2);
//         }
        
//         .logo:active {
//           transform: translateY(0) scale(0.98);
//         }
        
//         /* Enhanced Navigation Link Animations */
//         .nav-link { 
//           position: relative; 
//           transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
//           overflow: hidden;
//         }
        
//         .nav-link::before {
//           content: '';
//           position: absolute;
//           bottom: -2px;
//           left: 0;
//           width: 0;
//           height: 2px;
//           background: linear-gradient(90deg, #8b7355, #d6cc99);
//           transition: width 0.3s ease;
//         }
        
//         .nav-link::after {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: -100%;
//           width: 100%;
//           height: 100%;
//           background: linear-gradient(90deg, transparent, rgba(139, 115, 85, 0.1), transparent);
//           transition: left 0.5s ease;
//         }
        
//         .nav-link:hover::before,
//         .nav-link.active::before {
//           width: 100%;
//         }
        
//         .nav-link:hover::after {
//           left: 100%;
//         }
        
//         .nav-link:hover { 
//           color: #8b7355;
//           transform: translateY(-2px);
//           text-shadow: 0 2px 4px rgba(139, 115, 85, 0.1);
//         }
        
//         .nav-link.active { 
//           color: #1c1917;
//           font-weight: 600;
//           background: rgba(139, 115, 85, 0.08);
//           padding: 8px 16px;
//           border-radius: 6px;
//         }
        
//         /* Click Animation */
//         .nav-link.clicked {
//           color: #1c1917 !important;
//           background: rgba(139, 115, 85, 0.15);
//           transform: translateY(0) scale(0.95);
//           box-shadow: inset 0 2px 4px rgba(139, 115, 85, 0.2);
//         }
        
//         /* Ripple Effect */
//         .nav-link {
//           position: relative;
//           overflow: hidden;
//         }
        
//         .ripple {
//           position: absolute;
//           border-radius: 50%;
//           background: rgba(139, 115, 85, 0.3);
//           transform: scale(0);
//           animation: ripple-animation 0.6s linear;
//           pointer-events: none;
//         }
        
//         @keyframes ripple-animation {
//           to {
//             transform: scale(4);
//             opacity: 0;
//           }
//         }
        
//         /* Mobile Menu Enhancements */
//         .mobile-menu-item {
//           transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
//           position: relative;
//           overflow: hidden;
//         }
        
//         .mobile-menu-item::before {
//           content: '';
//           position: absolute;
//           left: 0;
//           top: 0;
//           width: 0;
//           height: 100%;
//           background: linear-gradient(90deg, rgba(139, 115, 85, 0.1), rgba(139, 115, 85, 0.05));
//           transition: width 0.3s ease;
//         }
        
//         .mobile-menu-item:hover::before {
//           width: 100%;
//         }
        
//         .mobile-menu-item:hover {
//           transform: translateX(8px);
//           color: #8b7355;
//           background: rgba(139, 115, 85, 0.05);
//         }
        
//         .mobile-menu-item.active {
//           color: #1c1917;
//           background: rgba(139, 115, 85, 0.1);
//           font-weight: 600;
//           border-left: 3px solid #8b7355;
//         }
        
//         .mobile-menu-item.clicked {
//           color: #1c1917 !important;
//           background: rgba(139, 115, 85, 0.2) !important;
//           transform: translateX(12px) scale(0.98);
//         }
        
//         /* Hamburger Menu Animation */
//         .hamburger {
//           transition: all 0.3s ease;
//           position: relative;
//         }
        
//         .hamburger::before {
//           content: '';
//           position: absolute;
//           inset: -4px;
//           border-radius: 50%;
//           background: transparent;
//           transition: all 0.3s ease;
//         }
        
//         .hamburger:hover::before {
//           background: rgba(139, 115, 85, 0.1);
//         }
        
//         .hamburger:hover {
//           transform: scale(1.1) rotate(5deg);
//         }
        
//         .hamburger:active {
//           transform: scale(0.9);
//         }
        
//         /* Smooth Mobile Menu Slide */
//         .mobile-menu-container {
//           transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
//         }
        
//         /* Enhanced backdrop blur */
//         .nav-backdrop {
//           backdrop-filter: blur(20px);
//           -webkit-backdrop-filter: blur(20px);
//         }
        
//         /* Staggered animation for mobile menu items */
//         .mobile-menu-item.animate {
//           animation: slideInFromRight 0.3s ease-out forwards;
//         }
        
//         @keyframes slideInFromRight {
//           from {
//             opacity: 0;
//             transform: translateX(20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateX(0);
//           }
//         }
//       `}</style>

//       <nav className={`nav-header fixed top-0 w-full z-50 ${
//         isVisible ? 'nav-visible' : 'nav-hidden'
//       } ${
//         scrollY > 50 
//           ? 'bg-[#f5f1eb]/95 nav-backdrop shadow-lg border-b border-stone-200/20' 
//           : 'bg-[#f5f1eb]/80 backdrop-blur-sm'
//       }`}>
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
//           <div className="flex items-center justify-between">
//             <div 
//               onClick={() => handleNavClick({ name: 'Home', path: '/' })}
//               className="logo text-xl sm:text-2xl font-bold text-stone-900 cursor-pointer" 
//               style={{fontFamily: "'Playfair Display', serif"}}
//             >
//               LUXE INTERIORS
//             </div>
            
//             <div className="hidden md:flex items-center space-x-2 lg:space-x-4">
//               {navigationItems.map((item) => (
//                 <div
//                   key={item.name}
//                   onClick={() => handleNavClick(item)}
//                   className={`nav-link text-sm lg:text-base font-medium cursor-pointer px-3 py-2 rounded-md ${
//                     isActiveRoute(item.path)
//                       ? 'active text-stone-900'
//                       : 'text-stone-600 hover:text-stone-900'
//                   } ${clickedItem === item.name ? 'clicked' : ''}`}
//                   onMouseDown={(e) => {
//                     // Create ripple effect
//                     const rect = e.currentTarget.getBoundingClientRect();
//                     const size = Math.max(rect.width, rect.height);
//                     const x = e.clientX - rect.left - size / 2;
//                     const y = e.clientY - rect.top - size / 2;
                    
//                     const ripple = document.createElement('div');
//                     ripple.classList.add('ripple');
//                     ripple.style.width = ripple.style.height = size + 'px';
//                     ripple.style.left = x + 'px';
//                     ripple.style.top = y + 'px';
                    
//                     e.currentTarget.appendChild(ripple);
                    
//                     setTimeout(() => {
//                       ripple.remove();
//                     }, 600);
//                   }}
//                 >
//                   {item.name}
//                 </div>
//               ))}
//             </div>

//             <button 
//               onClick={() => setIsMenuOpen(!isMenuOpen)}
//               className="md:hidden p-2 hamburger rounded-full hover:bg-stone-200/50 transition-all duration-300"
//             >
//               {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
//             </button>
//           </div>
//         </div>

//         {/* Enhanced Mobile Menu */}
//         <div className={`md:hidden overflow-hidden transition-all duration-400 ${
//           isMenuOpen ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0'
//         }`}>
//           <div className="px-4 py-3 space-y-1 bg-[#f5f1eb]/98 nav-backdrop border-t border-stone-200/20">
//             {navigationItems.map((item, index) => (
//               <div
//                 key={item.name}
//                 onClick={() => handleNavClick(item)}
//                 className={`mobile-menu-item block px-4 py-3 text-base font-medium rounded-lg cursor-pointer ${
//                   isActiveRoute(item.path)
//                     ? 'active text-stone-900'
//                     : 'text-stone-700 hover:text-stone-900'
//                 } ${clickedItem === item.name ? 'clicked' : ''} ${isMenuOpen ? 'animate' : ''}`}
//                 style={{ 
//                   animationDelay: isMenuOpen ? `${index * 50}ms` : '0ms',
//                   fontFamily: "'Inter', sans-serif"
//                 }}
//               >
//                 {item.name}
//               </div>
//             ))}
            
//             {/* Contact info in mobile menu */}
//             <div className="px-4 py-4 mt-4 border-t border-stone-200/20">
//               <div className="text-sm text-stone-600 space-y-1">
//                 <p className="font-medium text-stone-900 mb-2" style={{fontFamily: "'Playfair Display', serif"}}>
//                   Get in Touch
//                 </p>
//                 <p>+1 (555) 123-4567</p>
//                 <p>hello@luxeinteriors.com</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </nav>
//     </>
//   );
// };

// export default Header;


import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import CILogo from './Images/Ci.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [clickedItem, setClickedItem] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      
      setScrollY(currentScrollY);
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  // Reset states when route changes
  useEffect(() => {
    setIsMenuOpen(false);
    setClickedItem(null);
  }, [location]);

  const navigationItems = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActiveRoute = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  const handleNavClick = (item) => {
    setClickedItem(item.name);
    setIsMenuOpen(false);
    
    // Reset click state after animation
    setTimeout(() => {
      setClickedItem(null);
    }, 300);
    
    // Navigate with React Router
    navigate(item.path);
  };

  return (
    <>
      {/* Load Fonts */}
      <link
        href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;900&family=Inter:wght@300;400;500;600&display=swap"
        rel="stylesheet"
      />

      <style jsx>{`
        .nav-header {
          transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }
        
        .nav-hidden { 
          transform: translateY(-100%); 
        }
        
        .nav-visible { 
          transform: translateY(0); 
        }
        
        /* Enhanced Logo Animations */
        .logo { 
          transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          position: relative;
          overflow: hidden;
        }
        
        .logo::before {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 50%;
          width: 0;
          height: 2px;
          background: linear-gradient(90deg, transparent, #8b7355, transparent);
          transition: all 0.4s ease;
          transform: translateX(-50%);
        }
        
        .logo:hover::before {
          width: 100%;
        }
        
        .logo:hover { 
          transform: translateY(-2px);
          color: #8b7355;
          text-shadow: 0 2px 8px rgba(139, 115, 85, 0.2);
        }
        
        .logo:active {
          transform: translateY(0) scale(0.98);
        }
        
        /* Enhanced Navigation Link Animations */
        .nav-link { 
          position: relative; 
          transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          overflow: hidden;
        }
        
        .nav-link::before {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 0;
          height: 2px;
          background: linear-gradient(90deg, #8b7355, #d6cc99);
          transition: width 0.3s ease;
        }
        
        .nav-link::after {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(139, 115, 85, 0.1), transparent);
          transition: left 0.5s ease;
        }
        
        .nav-link:hover::before,
        .nav-link.active::before {
          width: 100%;
        }
        
        .nav-link:hover::after {
          left: 100%;
        }
        
        .nav-link:hover { 
          color: #8b7355;
          transform: translateY(-2px);
          text-shadow: 0 2px 4px rgba(139, 115, 85, 0.1);
        }
        
        .nav-link.active { 
          color: #1c1917;
          font-weight: 600;
          background: rgba(139, 115, 85, 0.08);
          padding: 8px 16px;
          border-radius: 6px;
        }
        
        /* Click Animation */
        .nav-link.clicked {
          color: #1c1917 !important;
          background: rgba(139, 115, 85, 0.15);
          transform: translateY(0) scale(0.95);
          box-shadow: inset 0 2px 4px rgba(139, 115, 85, 0.2);
        }
        
        /* Innovative Black Button Design */
        .quote-btn {
          position: relative;
          background: #000000;
          border: none;
          padding: 0;
          overflow: hidden;
          cursor: pointer;
          transition: all 0.5s cubic-bezier(0.23, 1, 0.320, 1);
        }
        
        .quote-btn-inner {
          position: relative;
          padding: 14px 32px;
          background: #000000;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          transition: all 0.5s cubic-bezier(0.23, 1, 0.320, 1);
          clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 100%, 12px 100%);
        }
        
        .quote-btn::before {
          content: '';
          position: absolute;
          top: 2px;
          left: 2px;
          right: 2px;
          bottom: 2px;
          background: #000000;
          z-index: -1;
          transition: all 0.5s cubic-bezier(0.23, 1, 0.320, 1);
          clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 100%, 12px 100%);
        }
        
        .quote-btn::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(45deg, #333333, #666666, #333333);
          z-index: -2;
          clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 100%, 12px 100%);
        }
        
        .quote-btn:hover .quote-btn-inner {
          background: #1a1a1a;
          transform: translate(-2px, -2px);
          box-shadow: 2px 2px 0 #333333;
        }
        
        .quote-btn:hover::before {
          background: #1a1a1a;
        }
        
        .quote-btn:active .quote-btn-inner {
          transform: translate(0, 0);
          box-shadow: none;
        }
        
        .quote-btn.clicked-btn .quote-btn-inner {
          background: #0a0a0a;
          transform: translate(-1px, -1px);
          box-shadow: 1px 1px 0 #222222;
        }
        
        /* Button Icon */
        .quote-btn-icon {
          width: 12px;
          height: 12px;
          border: 1.5px solid white;
          border-radius: 50%;
          position: relative;
          transition: all 0.3s ease;
        }
        
        .quote-btn-icon::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          width: 4px;
          height: 4px;
          background: white;
          border-radius: 50%;
          transform: translate(-50%, -50%);
          transition: all 0.3s ease;
        }
        
        .quote-btn:hover .quote-btn-icon {
          transform: rotate(180deg);
        }
        
        .quote-btn:hover .quote-btn-icon::before {
          width: 6px;
          height: 6px;
        }
        
        /* Premium Mobile Button Design */
        .mobile-quote-btn {
          position: relative;
          background: #000000;
          color: white;
          margin: 12px 16px;
          padding: 0;
          border: none;
          cursor: pointer;
          overflow: hidden;
          transition: all 0.5s cubic-bezier(0.23, 1, 0.320, 1);
        }
        
        .mobile-quote-btn-inner {
          position: relative;
          padding: 16px 28px;
          background: #000000;
          color: white;
          text-align: center;
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 0.15em;
          transition: all 0.5s cubic-bezier(0.23, 1, 0.320, 1);
          clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 100%, 12px 100%);
        }
        
        .mobile-quote-btn::before {
          content: '';
          position: absolute;
          top: 2px;
          left: 2px;
          right: 2px;
          bottom: 2px;
          background: #000000;
          z-index: -1;
          transition: all 0.5s cubic-bezier(0.23, 1, 0.320, 1);
          clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 100%, 12px 100%);
        }
        
        .mobile-quote-btn::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(45deg, #333333, #666666, #333333);
          z-index: -2;
          clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 100%, 12px 100%);
        }
        
        .mobile-quote-btn:hover .mobile-quote-btn-inner {
          background: #1a1a1a;
          transform: translate(-2px, -2px);
          box-shadow: 2px 2px 0 #333333;
        }
        
        .mobile-quote-btn:hover::before {
          background: #1a1a1a;
        }
        
        .mobile-quote-btn:active .mobile-quote-btn-inner {
          transform: translate(0, 0);
          box-shadow: none;
        }
        
        .mobile-quote-btn.clicked .mobile-quote-btn-inner {
          background: #0a0a0a;
          transform: translate(-1px, -1px);
          box-shadow: 1px 1px 0 #222222;
        }
        
        /* Ripple Effect */
        .ripple {
          position: absolute;
          border-radius: 50%;
          background: rgba(139, 115, 85, 0.3);
          transform: scale(0);
          animation: ripple-animation 0.6s linear;
          pointer-events: none;
        }
        
        @keyframes ripple-animation {
          to {
            transform: scale(4);
            opacity: 0;
          }
        }
        
        /* Mobile Menu Enhancements */
        .mobile-menu-item {
          transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          position: relative;
          overflow: hidden;
        }
        
        .mobile-menu-item::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          width: 0;
          height: 100%;
          background: linear-gradient(90deg, rgba(139, 115, 85, 0.1), rgba(139, 115, 85, 0.05));
          transition: width 0.3s ease;
        }
        
        .mobile-menu-item:hover::before {
          width: 100%;
        }
        
        .mobile-menu-item:hover {
          transform: translateX(8px);
          color: #8b7355;
          background: rgba(139, 115, 85, 0.05);
        }
        
        .mobile-menu-item.active {
          color: #1c1917;
          background: rgba(139, 115, 85, 0.1);
          font-weight: 600;
          border-left: 3px solid #8b7355;
        }
        
        .mobile-menu-item.clicked {
          color: #1c1917 !important;
          background: rgba(139, 115, 85, 0.2) !important;
          transform: translateX(12px) scale(0.98);
        }
        
        /* Mobile Get Quote Button */
        .mobile-quote-btn {
          background: #1c1917;
          color: white;
          margin: 8px 16px;
          padding: 12px 20px;
          border-radius: 6px;
          text-align: center;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          transition: all 0.3s ease;
        }
        
        .mobile-quote-btn:hover {
          background: #000000;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
        }
        
        .mobile-quote-btn.clicked {
          background: #000000 !important;
          transform: translateY(0) scale(0.98);
        }
        
        /* Hamburger Menu Animation */
        .hamburger {
          transition: all 0.3s ease;
          position: relative;
        }
        
        .hamburger::before {
          content: '';
          position: absolute;
          inset: -4px;
          border-radius: 50%;
          background: transparent;
          transition: all 0.3s ease;
        }
        
        .hamburger:hover::before {
          background: rgba(139, 115, 85, 0.1);
        }
        
        .hamburger:hover {
          transform: scale(1.1) rotate(5deg);
        }
        
        .hamburger:active {
          transform: scale(0.9);
        }
        
        /* Enhanced backdrop blur */
        .nav-backdrop {
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
        }
        
        /* Staggered animation for mobile menu items */
        .mobile-menu-item.animate {
          animation: slideInFromRight 0.3s ease-out forwards;
        }
        
        @keyframes slideInFromRight {
          from {
            opacity: 0;
            transform: translateX(20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
      `}</style>

      <nav className={`nav-header fixed top-0 w-full z-50 ${
        isVisible ? 'nav-visible' : 'nav-hidden'
      } ${
        scrollY > 50 
          ? 'bg-[#f5f1eb]/95 nav-backdrop shadow-lg border-b border-stone-200/20' 
          : 'bg-[#f5f1eb]/80 backdrop-blur-sm'
      }`}>
        {/* <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div 
              onClick={() => handleNavClick({ name: 'Home', path: '/' })}
              className="logo text-xl sm:text-2xl font-bold text-stone-900 cursor-pointer" 
              style={{fontFamily: "'Playfair Display', serif"}}
            >
              CONSTRUCT INSIDES
            </div>
            
            <div className="hidden md:flex items-center space-x-2 lg:space-x-4">
              {navigationItems.map((item) => (
                <div
                  key={item.name}
                  onClick={() => handleNavClick(item)}
                  className={`nav-link text-sm lg:text-base font-medium cursor-pointer px-3 py-2 rounded-md ${
                    isActiveRoute(item.path)
                      ? 'active text-stone-900'
                      : 'text-stone-600 hover:text-stone-900'
                  } ${clickedItem === item.name ? 'clicked' : ''}`}
                  onMouseDown={(e) => {
                    // Create ripple effect
                    const rect = e.currentTarget.getBoundingClientRect();
                    const size = Math.max(rect.width, rect.height);
                    const x = e.clientX - rect.left - size / 2;
                    const y = e.clientY - rect.top - size / 2;
                    
                    const ripple = document.createElement('div');
                    ripple.classList.add('ripple');
                    ripple.style.width = ripple.style.height = size + 'px';
                    ripple.style.left = x + 'px';
                    ripple.style.top = y + 'px';
                    
                    e.currentTarget.appendChild(ripple);
                    
                    setTimeout(() => {
                      ripple.remove();
                    }, 600);
                  }}
                >
                  {item.name}
                </div>
              ))}
              
            
              <button
                onClick={() => handleNavClick({ name: 'Get Quote', path: '/contact' })}
                className={`quote-btn ml-4 ${clickedItem === 'Get Quote' ? 'clicked-btn' : ''}`}
              >
                <div className="quote-btn-inner" style={{ fontFamily: "'Inter', sans-serif" }}>
                  <span className="text-sm lg:text-base font-medium tracking-[0.15em] uppercase">
                    Get Quote
                  </span>
                  <div className="quote-btn-icon"></div>
                </div>
              </button>
            </div>

            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 hamburger rounded-full hover:bg-stone-200/50 transition-all duration-300"
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div> */}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
  <div className="flex items-center justify-between">
    <div 
      onClick={() => handleNavClick({ name: 'Home', path: '/' })}
      className="logo flex items-center text-xl sm:text-2xl font-bold text-stone-900 cursor-pointer" 
      style={{fontFamily: "'Playfair Display', serif"}}
    >
      <img 
        src={CILogo}
        alt="Construct Insides Logo" 
        className="w-8 h-8 sm:w-10 sm:h-10 object-cover rounded-full mr-4 sm:mr-5"
      />
      <span>CONSTRUCT&nbsp;&nbsp;&nbsp;INSIDES</span>
    </div>
    
    <div className="hidden md:flex items-center space-x-2 lg:space-x-4">
      {navigationItems.map((item) => (
        <div
          key={item.name}
          onClick={() => handleNavClick(item)}
          className={`nav-link text-sm lg:text-base font-medium cursor-pointer px-3 py-2 rounded-md ${
            isActiveRoute(item.path)
              ? 'active text-stone-900'
              : 'text-stone-600 hover:text-stone-900'
          } ${clickedItem === item.name ? 'clicked' : ''}`}
          onMouseDown={(e) => {
            // Create ripple effect
            const rect = e.currentTarget.getBoundingClientRect();
            const size = Math.max(rect.width, rect.height);
            const x = e.clientX - rect.left - size / 2;
            const y = e.clientY - rect.top - size / 2;
            
            const ripple = document.createElement('div');
            ripple.classList.add('ripple');
            ripple.style.width = ripple.style.height = size + 'px';
            ripple.style.left = x + 'px';
            ripple.style.top = y + 'px';
            
            e.currentTarget.appendChild(ripple);
            
            setTimeout(() => {
              ripple.remove();
            }, 600);
          }}
        >
          {item.name}
        </div>
      ))}
      
      {/* Innovative Black Get Quote Button */}
      <button
        onClick={() => handleNavClick({ name: 'Get Quote', path: '/contact' })}
        className={`quote-btn ml-4 ${clickedItem === 'Get Quote' ? 'clicked-btn' : ''}`}
      >
        <div className="quote-btn-inner" style={{ fontFamily: "'Inter', sans-serif" }}>
          <span className="text-sm lg:text-base font-medium tracking-[0.15em] uppercase">
            Get Quote
          </span>
          <div className="quote-btn-icon"></div>
        </div>
      </button>
    </div>

    <button 
      onClick={() => setIsMenuOpen(!isMenuOpen)}
      className="md:hidden p-2 hamburger rounded-full hover:bg-stone-200/50 transition-all duration-300"
    >
      {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
    </button>
  </div>
</div>


        {/* Enhanced Mobile Menu */}
        <div className={`md:hidden overflow-hidden transition-all duration-400 ${
          isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}>
          <div className="px-4 py-3 space-y-1 bg-[#f5f1eb]/98 nav-backdrop border-t border-stone-200/20">
            {navigationItems.map((item, index) => (
              <div
                key={item.name}
                onClick={() => handleNavClick(item)}
                className={`mobile-menu-item block px-4 py-3 text-base font-medium rounded-lg cursor-pointer ${
                  isActiveRoute(item.path)
                    ? 'active text-stone-900'
                    : 'text-stone-700 hover:text-stone-900'
                } ${clickedItem === item.name ? 'clicked' : ''} ${isMenuOpen ? 'animate' : ''}`}
                style={{ 
                  animationDelay: isMenuOpen ? `${index * 50}ms` : '0ms',
                  fontFamily: "'Inter', sans-serif"
                }}
              >
                {item.name}
              </div>
            ))}
            
            {/* Innovative Mobile Get Quote Button */}
            <button
              onClick={() => handleNavClick({ name: 'Get Quote', path: '/contact' })}
              className={`mobile-quote-btn cursor-pointer ${clickedItem === 'Get Quote' ? 'clicked' : ''} ${isMenuOpen ? 'animate' : ''}`}
              style={{ 
                animationDelay: isMenuOpen ? `${navigationItems.length * 50 + 50}ms` : '0ms'
              }}
            >
              <div className="mobile-quote-btn-inner" style={{ fontFamily: "'Inter', sans-serif" }}>
                Get Quote
              </div>
            </button>
            
            {/* Contact info in mobile menu */}
            <div className="px-4 py-4 mt-4 border-t border-stone-200/20">
              <div className="text-sm text-stone-600 space-y-1">
                <p className="font-medium text-stone-900 mb-2" style={{fontFamily: "'Playfair Display', serif"}}>
                  Get in Touch
                </p>
                <p>+91 95735 78899</p>
              
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;